<mat-button-toggle-group
  [name]="name"
  [attr.aria-label]="name + ' Toggle'"
  hideSingleSelectionIndicator
  (change)="onChangeInner($event)"
  [value]="value"
  >
  @for (option of options; track option) {
    <mat-button-toggle [id]="name + '-' + option.value"  [value]="option.value" class="slim">{{ option.label }}</mat-button-toggle>
  }
</mat-button-toggle-group>
